import { Injectable } from "@angular/core";
import html2canvas from "html2canvas";
import { HttpErrorResponse } from "@angular/common/http";

interface ErrorInfo {
  timestamp: Date;
  error: string;
  userAgent: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class IssueReportService {
  private errors: ErrorInfo[] = [];
  private maxErrors = 50;
  private screenShot: string = "";
  private userDetails: string = "";
  private userEmail: string = "";

  captureUserDetails(userDetails: string)  {
    this.userDetails = userDetails;
  }
  captureUserEmail(userEmail: string | null) {
    this.userEmail = userEmail ?? "";
  }

  captureError(error: HttpErrorResponse) {
    const errorInfo = {
      timestamp: new Date(),
      error: JSON.stringify(error),
      userAgent: navigator.userAgent,
      url: window.location.href,
    };
    this.errors.push(errorInfo);
    if (this.errors.length > this.maxErrors) {
      this.errors.shift();
    }
  }

  public captureScreenshot(): string {
    const canvas = document.createElement('canvas');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    console.log(canvas.width, canvas.height);
    html2canvas(document.body).then(canvas => {
      this.screenShot = canvas.toDataURL();
      console.log(this.screenShot)
    });
    return '';
  }

  getErrors() {
    return this.errors.map(error => JSON.stringify(error));
  }

  getScreenShot() {
    return this.screenShot;
  }

  getUserEmail() {
    return this.userEmail;
  }

  getUserDetails() {
    return this.userDetails;
  }
}
